import React from "react";
import MapView from "./components/MapView";
import eventsData from "./data/events.json"; // Import the JSON directly

function App() {
  return (
    <div className="App">
      
      <MapView eventsData={eventsData} />
    </div>
  );
}

export default App;
